import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import BottomNav from './components/BottomNav';
import Calculate from './pages/Calculate';
import Tenants from './pages/Tenants';
import History from './pages/History';
import Settings from './pages/Settings';

function App() {
  const [currentPage, setCurrentPage] = useState('calculate');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [bibleVerse, setBibleVerse] = useState(null);
  const [showBibleVerse, setShowBibleVerse] = useState(() => {
    const saved = localStorage.getItem('showBibleVerse');
    return saved !== null ? saved === 'true' : true;
  });

  useEffect(() => {
    localStorage.setItem('showBibleVerse', showBibleVerse.toString());
  }, [showBibleVerse]);

  useEffect(() => {
    fetchBibleVerse();
  }, []);

  const fetchBibleVerse = async () => {
    try {
      const response = await fetch('/api/get-bible-verse');
      const result = await response.json();
      if (result.success) {
        setBibleVerse(result.data);
      }
    } catch (error) {
      console.error('Error fetching Bible verse:', error);
    }
  };

  const renderPage = () => {
    const verseToShow = showBibleVerse ? bibleVerse : null;
    
    switch (currentPage) {
      case 'calculate':
        return <Calculate bibleVerse={verseToShow} />;
      case 'tenants':
        return <Tenants bibleVerse={verseToShow} />;
      case 'history':
        return <History bibleVerse={verseToShow} />;
      case 'settings':
        return <Settings onBibleVerseToggle={setShowBibleVerse} showBibleVerse={showBibleVerse} bibleVerse={verseToShow} />;
      default:
        return <Calculate bibleVerse={verseToShow} />;
    }
  };

  return (
    <div className="app">
      <Header 
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        bibleVerse={showBibleVerse ? bibleVerse : null}
      />
      
      <div className="app-body">
        <Sidebar 
          isOpen={sidebarOpen}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          onClose={() => setSidebarOpen(false)}
        />
        
        <main className={`main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
          <div className="container">
            {renderPage()}
          </div>
        </main>
      </div>

      <BottomNav currentPage={currentPage} onPageChange={setCurrentPage} />
    </div>
  );
}

export default App;